import { ref, computed, reactive } from "vue";
import dashboardApi from "../api";
import Utils from "@/common/utils";

export default function (type, chartType = "donut") {
  const data = reactive({
    series: [],
    options: {
      chart: {
        fontFamily: "Source Sans Pro, Arial, sans-serif",
        type: chartType,
      },
      colors: [
        "#5B9BD5",
        "#4472C4",
        "#FFC000",
        "#A5A5A5",
        "#ED7D31",
        "#0d233a",
        "#8bbc21",
        "#910000",
        "#1aadce",
        "#492970",
        "#f28f43",
        "#77a1e5",
        "#c42525",
        "#a6c96a",
      ],
      labels: [],
      legend: {
        show: true,
        showForSingleSeries: true,
        position: "right",
        horizontalAlign: "right",
        verticalAlign: "center",
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        theme: "dark",
        x: {
          show: false,
        },
        y: {
          formatter: (v) => v + " " + Utils.getServiceWordByCount(v),
          title: {
            formatter: function (v) {
              if (type == 1) return v + " год: ";
              else return v + ": ";
            },
          },
        },
      },
    },
  });
  const total = ref(0);

  const loadReport = async () => {
    const res = await dashboardApi.getIMARReport({ type });
    total.value = 0;
    total.value = res.data.reduce(
      (acc, curr) => (acc += curr.count),
      total.value
    );

    Object.assign(data, {
      ...data,
      series: res.data.map((item) => item.count),
      options: { ...data.options, labels: res.data.map((item) => item.text) },
    });
  };
  loadReport();
  return {
    data: computed(() => data),
    loadReport,
    total: computed(() => total),
  };
}
